import { render, staticRenderFns } from "./settingsdialog.vue?vue&type=template&id=578fd08a&"
import script from "./settingsdialog.vue?vue&type=script&lang=ts&"
export * from "./settingsdialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578fd08a')) {
      api.createRecord('578fd08a', component.options)
    } else {
      api.reload('578fd08a', component.options)
    }
    module.hot.accept("./settingsdialog.vue?vue&type=template&id=578fd08a&", function () {
      api.rerender('578fd08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settingsdialog.vue"
export default component.exports